<ion-card
  tappable
  class="smr-booking-history-card smr-hover"
  [ngClass]="{ 'smr-opacity-0-5': booking.status == 6 }"
>
  <ion-row [ngClass]="[statuses[booking.status].class, 'smr-booking-status']">
    <ion-col width-100>{{ statuses[booking.status + ""].name }}</ion-col>
  </ion-row>
  <ion-card-header>
    {{ booking.getStartDateTime() | salonMonsterDate : "dddd, MMMM D, Y" }}
  </ion-card-header>

  <ion-card-content>
    <ion-grid *ngIf="displayClientName">
      <ion-row>
        <ion-col>
          {{ booking.getClient().getFirstName() }}
          {{ booking.getClient().getLastName() }}
        </ion-col>
      </ion-row>
    </ion-grid>

    <div style="padding: 10px">
      <div *ngFor="let service of booking.getServices()">
        <div *ngIf="(booking.status != 6 && !service.deleted) || (booking.status == 6)">
          <ion-item lines="none">
            <ion-avatar
              slot="start"
              [hidden]="
                service.getStylist().getPhotoUrl() == '' ||
                service.getStylist().getPhotoUrl() == undefined ||
                service.getStylist().getPhotoUrl() == null
              "
            >
              <img
                src="{{ env_config.STAFF_THUMBNAIL_PHOTO_ROOT }}/{{
                  service.getStylist().getPhotoUrl()
                }}"
              />
            </ion-avatar>
            <smr-circle-text-avatar
              slot="start"
              [hidden]="
                service.getStylist().getPhotoUrl() != '' &&
                service.getStylist().getPhotoUrl() != undefined &&
                service.getStylist().getPhotoUrl() != null
              "
              [firstName]="service.getStylist().getFirstName()"
              [lastName]="service.getStylist().getLastName()"
            >
            </smr-circle-text-avatar>

            <div>
              <b>{{
                service.getStartDateTime() | salonMonsterDate : "h:mm a"
              }}</b>
              - {{ service.getEndDateTime() | salonMonsterDate : "h:mm a" }}
              <br />
              {{ service.getServiceDefinition().getServiceName() }}
              <br />
              {{ service.getPrice() | salonMonsterCurrency }}
            </div>
          </ion-item>
          <div
            class="smr-booking-servicenotes"
            *ngIf="service.hasStylistNotes()"
          >
            {{ service.getStylistNotes() }}
          </div>
          <div
            class="smr-booking-servicenotes"
            *ngIf="service.hasClientNotes()"
          >
            <strong>Client Note</strong> {{ service.getClientNotes() }}
          </div>
        </div>
      </div>
    </div>
  </ion-card-content>
</ion-card>
